import * as Operators from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
const unsupportedOperators = [Operators.UpdatedAfter, Operators.UpdatedBefore];
export const operatorSupportsExternalOptions = operator => {
  return !unsupportedOperators.includes(operator.constructor);
};